export const AUTH_SESSION_ID_KEY = 'elma.cortex.auth.session.id';
export const AUTH_SESSION_ID_HEADER_NAME = 'auth-session-id';
export const AUTH_CHECK_INTERVAL = 1000;
